<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="7"
          ><div class="search-area-div">人员：</div>
          <el-input v-model="page.staffName" class="ipt-sty" placeholder="请输入人员"></el-input
        ></el-col>
        <el-col :span="9">
          <div class="search-area-div w110">推广费发放主体：</div>
          <el-select v-model="page.levyCompanyGuid" placeholder="请选择" class="ipt-sty">
            <el-option v-for="item in tenantListDz" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <div class="search-area-div">签约公司：</div>
          <el-select v-model="page.insuredCompanyGuid" placeholder="请选择" class="ipt-sty" filterable>
            <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="24" class="mt15 t-right">
        <el-col :span="24">
          <div>
            <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty">清空</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff">
      <div class="button-area">
        <!-- <el-button size="medium" type="info" @click="update()">批量上传回执单</el-button> -->
        <el-button size="medium" type="info" @click="alonePayAmountToOtherPlatform" v-loading.fullscreen.lock="fullscreenLoading">单独发送到人力服务平台</el-button> 
        <!-- <el-button plain size="medium" @click="add()">查看发放凭证</el-button> -->
        <!-- <el-button plain size="medium" @click="getCompanyReceiptUrl()">同步回执单</el-button> -->
        <el-button plain size="medium" @click="getReceiptUrlList()">同步回执单</el-button>
        <!-- <el-button size="medium" type="info" @click="update()">查看发放凭证</el-button> -->
      </div>
      <div class="summary-sty mt15">
        人数：<b class="fontC-4fa1a4"> {{ tableData.peopleNum }} </b>推广费发放主体：<b class="fontC-4fa1a4 mlf10">
          {{ tableData.levyCompanyNum }} 家
        </b>
        签约公司：<b class="fontC-4fa1a4 mlf10"> {{ tableData.insuredCompanyNum }}  家  </b>推广费总额(元)<b
          class="fontC-4fa1a4 mlf10"
        >
          {{ tableData.performanceTotalAmount  | numDigit | numFmt}}</b
        >
      </div>
      <el-table :data="tableData.performanceReportDetailVOS" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="人员"
          header-align="center"
          align="center"
          width="150"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="organisationNames" label="组织" header-align="center" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.organisationNames | roleNames }}</template>
        </el-table-column>
        <el-table-column prop="positionNames" label="岗位" header-align="center" align="center" width="150">
          <template slot-scope="scope">{{ scope.row.positionNames | roleNames }}</template>
        </el-table-column>
        <el-table-column prop="performanceAmount" label="推广费(元)" header-align="center" align="right" width="150">
          <template slot-scope="scope">{{ scope.row.performanceAmount | numDigit | numFmt }}</template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          header-align="center"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="idCode"
          label="身份证号"
          header-align="center"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="levyCompanyName"
          label="推广费发放主体(代征公司)"
          header-align="center"
          align="center"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="insuredCompanyName"
          label="签约公司"
          header-align="center"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="bankAccount"
          label="账户"
          header-align="center"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column prop="bank" label="开户行" header-align="center" align="center" width="200"> </el-table-column>
        <el-table-column prop="payState" label="发放状态" header-align="center" align="center" width="100" fixed="right"> 
                   <template slot-scope="scope">{{ scope.row.payState | payState}}</template>
        </el-table-column> 
        <el-table-column prop="payFeedback" label="发放反馈" header-align="center" align="center" width="100" fixed="right" show-overflow-tooltip> 
        </el-table-column> 
        <!-- <el-table-column
          prop="bankAccount"
          label="回执单"
          header-align="center"
          align="center"
          fixed="right"
          width="150"
        >
          <template slot-scope="scope">
            <div v-for="path in scope.row.receiptAttach" class="fl ml16">
              <el-image style="width: 40px; height: 40px" :src="path.path" :preview-src-list="scope.row.imgPathList">
              </el-image
              ><br />
              <img
                width="15"
                class="fl"
                src="../../assets/images/del.png"
                style="position: absolute; margin-top: -50px; margin-left: 10px"
                @click="delImg(scope.row.guid, path)"
              />
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="bank" label="操作" header-align="center" align="center" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button size="small" type="info" @click="getLookUrl(scope.row.receiptAttach)">查看回执单</el-button>
            <!-- <el-button size="small" type="info" @click="getReceiptUrl(scope.row.guid,scope.row.payOrderGuid)">同步回执单</el-button> -->
            <el-button size="small" type="info" @click="getImg(scope.row.guid, scope.row.receiptAttach)">上传回执单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--  <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   -->
    <el-dialog title="上传回执单确定发放" :visible.sync="dialogVisible1" width="50%">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="回执单:">
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl1" alt="" />
          </el-dialog>
          <el-upload
            action="#"
            name="image"
            class="fl"
            :limit="2"
            list-type="picture-card"
            :headers="token"
            :file-list="fileList"
            :on-exceed="handleExceed"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :http-request="uploadImage"
          >
            <div slot="image" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                  <i class="el-icon-download"></i>
                </span>
                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="medium" type="info" @click="payPerformance">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="查看发放凭证" :visible.sync="dialogVisible2" width="50%">
      <div class="h260">
        <div v-for="im in sendVoucherAttachList" class="fl ml16">
          <el-image style="width: 100px; height: 100px" :src="im.path" :preview-src-list="srcList"> </el-image>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      fullscreenLoading: false,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 1000,
        totalPage: 0,
        totalRows: 0,
        levyCompanyGuid: '',
        insuredCompanyGuid: '',
        staffName: '',
        performanceGuid: '',
        performanceReportGuid: '',
        isUploadReceipt: '',
      },
      dialogVisible2: false,
      dialogVisible1: false,
      fileList: [],
      dialogImageUrl1: '',
      dialogVisible: false,
      disabled: false,
      sendVoucherAttach: [],
      ruleForm: {
        sendTime: '',
      },
      rules: {
        sendTime: [{ type: 'date', required: true, message: '请选择日期', trigger: 'change' }],
      },
      tenantList: [],
      tenantListDz: [],
      tableData: '',
      sendTime: '',
      right: 'right',
      performanceReprotDetailGuid: '',
      sendVoucherAttachList: [],
      srcList: [],
      tableLoading: false,
      height:window.innerHeight - 360, 
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getTenant();
    this.getTenantDz();
    // this.getCurrentManageStaff();
  },
  methods: {
    getTenant() {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { enterpriseCates: ['9903', '9904'], pageSize: 100 })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data.records;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    add() {
      let self = this;
      self.dialogVisible2 = true;
      self.sendVoucherAttachList = JSON.parse(self.tableData.sendVoucherAttach);
      console.log(self.sendVoucherAttachList);
      if (self.sendVoucherAttachList != null && self.sendVoucherAttachList.length > 0) {
        self.sendVoucherAttachList.forEach(function (i) {
          self.srcList.push(i.path);
        });
      }
    },
    update() {
      let self = this;
      self.$message('敬请期待');
    },
    getTenantDz() {
      let self = this;
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, { enterpriseCate: '9904' }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantListDz = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getImg(guid, receiptAttach) {
      let self = this;
      self.dialogVisible1 = true;
      self.performanceReprotDetailGuid = guid;
      self.sendVoucherAttach = [];
      self.fileList = [];
      if (receiptAttach != null && receiptAttach.length > 0) {
        receiptAttach.forEach(function (i) {
          let item = {
            name: '回执单',
            url: i.path,
          };
          self.fileList.push(item);
          let item1 = {
            fileName: '回执单',
            path: i.path,
          };
          self.sendVoucherAttach.push(item1);
        });
      }
    },
    uploadImage(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.url, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // self.ruleForm.platformLogo = res.data.data;
            let item = {
              name: '回执单',
              url: res.data.data,
            };
            let item1 = {
              fileName: '回执单',
              path: res.data.data,
            };
            self.sendVoucherAttach.push(item1);
            self.fileList.push(item);
            // self.ruleForm.icon = res.data.data;
            self.$message.success('上传成功');
            // setTimeout(function () {
            //   self.payPerformance();
            // }, 500);
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    alonePayAmountToOtherPlatform(){
          let self = this; 
          self.fullscreenLoading = true;
          // self.ruleForm.sendTime = self.$moment(self.ruleForm.sendTime).format('YYYY-MM-DD HH:mm:ss');
          self.api.post(`/${serverConfig.msSalesPerformService}/performance/data/alone-pay-amount-to-other-platform`,{'performanceGuid':self.$router.history.current.query.guid}).then(res => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success("发送成功");
              self.getData();
              // this.$router.push({path: "/performancePayment"})
              // self.tableData = res.data.data.records;
              // self.page.totalPage = res.data.data.totalPages;
              // self.page.totalRows = res.data.data.totalRows; 
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
    getReceiptUrlList(){
       let self = this;
       self.tableData.performanceReportDetailVOS.forEach(function(i){
                self.getReceiptUrl(i.guid,i.payOrderGuid);
       })
    },
    getCompanyReceiptUrl(){
          let self = this; 
          self.fullscreenLoading = true; 
          self.api.postJson(`/${serverConfig.msUserRemunerationService}/flexibleLabor/get-company-receipt-url`,{'levyCompanyGuid':self.tableData.levyCompanyGuid}).then(res => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if(res.data.data != null){
                    self.uploadImageBaseStringPz(guid,res.data.data.fileBase64,res.data.data.suffix);
              }
              self.$message.success("同步成功");
              // self.getData(); 
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
    uploadImageBaseStringPz(guid,baseStr,suffix){
          let self = this;  
          self.api.postJson(`/${serverConfig.msCommonAdminCloudService}/obs/upload-image-base-string`,{'baseStr':baseStr,'suffix':suffix}).then(res => { 
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
                  let path = res.data.data;
                  console.log(path.split('/'));
                  // self.getData();
                  let receiptAttach = [];
                  let item = {
                    fileName:path.split('/')[3],
                    path:path
                  }
                  receiptAttach.push(item);
                  self.payPerformanceList(guid,receiptAttach);
                  self.getData();
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
    getReceiptUrl(guid,payOrderGuid){
          let self = this; 
          self.fullscreenLoading = true; 
          self.api.postJson(`/${serverConfig.msUserRemunerationService}/flexibleLabor/get-receipt-url`,{'performanceReportDetailGuid':guid,'payOrderGuid':payOrderGuid,'levyCompanyGuid':self.tableData.levyCompanyGuid}).then(res => { 
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if(res.data.data != null){
                    self.uploadImageBaseString(guid,res.data.data.fileBase64,res.data.data.suffix);
              }
              self.$message.success("同步成功");
              // self.getData();
            } else {
              self.fullscreenLoading = false; 
              self.$message.error(res.data.msg);

            }
          });
    },
    uploadImageBaseString(guid,baseStr,suffix){
          let self = this;  
          self.api.postJson(`/${serverConfig.msCommonAdminCloudService}/obs/upload-image-base-string`,{'baseStr':baseStr,'suffix':suffix}).then(res => { 
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
                  let path = res.data.data; 
                  // self.getData();
                  let receiptAttach = [];
                  let item = {
                    fileName:path.split('/')[3],
                    path:path
                  }
                  receiptAttach.push(item);
                  self.payPerformanceList(guid,receiptAttach);
                  self.getData();
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
    payPerformanceList(guid,receiptAttach) {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/performance/data/upload-performance-receipt`, {
          performanceReprotDetailGuid: guid,
          receiptAttach: receiptAttach,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // self.dialogVisible1 = false;
            // self.$message.success('上传成功！');
            // self.getData();
            // self.tableData = res.data.data.records;
            // self.page.totalPage = res.data.data.totalPages;
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getLookUrl(receiptAttach){
      if(receiptAttach != null){
            window.open(receiptAttach[0].path);
      }else{
            this.$message.warning(`暂无回执单`);
      }  
    },
    handleRemove(file) {
      let self = this;
      console.log(file.url);
      self.sendVoucherAttach.forEach(function (i, index) {
        if (i.path == file.url) {
          self.sendVoucherAttach.splice(index, 1);
        }
      });
      self.fileList.forEach(function (j, ind) {
        if (j.url == file.url) {
          self.fileList.splice(ind, 1);
        }
      });
      console.log(self.fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 2 个文件`);
    },
    handleDownload(file) {
      console.log(file);
    },

    empty() {
      let self = this;
      self.timeList = '';
      self.timeListS = '';
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        userName: '',
        startTime: '',
        endTime: '',
        province: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.page.performanceGuid = self.$router.history.current.query.guid;
      self.tableLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-report-summary-detail`, self.page)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableLoading = false;
            self.tableData = res.data.data;
            if (
              self.tableData.performanceReportDetailVOS != null &&
              self.tableData.performanceReportDetailVOS.length > 0
            ) {
              self.tableData.performanceReportDetailVOS.forEach(function (i) {
                i.imgPathList = [];
                if (i.receiptAttach != null && i.receiptAttach.length > 0) {
                  i.receiptAttach.forEach(function (j) {
                    i.imgPathList.push(j.path);
                  });
                }
              });
            }
            console.log(self.tableData.performanceReportDetailVOS[0]);
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    payPerformance() {
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/performance/data/upload-performance-receipt`, {
          performanceReprotDetailGuid: self.performanceReprotDetailGuid,
          receiptAttach: self.sendVoucherAttach,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogVisible1 = false;
            self.$message.success('上传成功！');
            self.getData();
            // self.tableData = res.data.data.records;
            // self.page.totalPage = res.data.data.totalPages;
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    delImg(guid, path) {
      let self = this;
      self.sendVoucherAttach = [];
      self.sendVoucherAttach.push(path);
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/performance/data/delete-performance-receipt`, {
          performanceReprotDetailGuid: guid,
          receiptAttach: self.sendVoucherAttach,
        })
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success('删除成功！');
            self.getData();
            // self.tableData = res.data.data.records;
            // self.page.totalPage = res.data.data.totalPages;
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>